export default __webpack_public_path__ + "static/media/linkCode.017e9345.svg";